import { SectionWrapper } from '../components/SectionWrapper';
import { StoryCard } from '../components/StoryCard';

import zrinkaCoverUrl from '@/images/zrinka_cover.jpg';
import styles from './StahuljakStorySection.module.css';

export function StahuljakStorySection() {
  return (
    <SectionWrapper data-testid="marketing-section-stahuljak-story">
      <div className={styles.section}>
        <StoryCard
          body="Professor Zrinka Stahuljak had decades of lecture notes and primary sources but no courseware that fit her course. Kudu turned her materials into a complete AI-enabled humanities course in weeks. Students, TAs, and faculty praised the result. UCLA History has since launched two more AI-assisted courses, with three more in the pipeline. Faculty kept the copyright. No lock-in. No publisher contract."
          coverageLine="Also covered in UCLA Newsroom · Daily Bruin"
          ctaHref="/press"
          ctaLabel="Read more stories"
          eyebrow="A story from UCLA"
          headline="UCLA's first AI-curated humanities course."
          imageAlt="Course cover for UCLA's AI-curated humanities course, The Uses of Literature."
          imageSrc={zrinkaCoverUrl}
          imageTitle="The Uses of Literature"
          pullQuote="Instead of banning AI, this UCLA literature class embraces it."
          pullQuoteAttribution="LAist, February 2025"
        />
      </div>
    </SectionWrapper>
  );
}
